import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jps-pf-footer',
  templateUrl: './pf-footer.component.html',
  styleUrls: ['./pf-footer.component.scss']
})
export class PfFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
